/* eslint-disable camelcase */
import routePathEnum from 'enums/routePathEnum';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const privateIntegration: any = {
    profilID2: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID5: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID6: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page197'
                },

                F28: {
                    url: '/duverne-informace/F28/page605'
                },
                F30: {
                    url: '/duverne-informace/F30/page197'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID10: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID25: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID26: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID28: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID29: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID38: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F38: {
                    url: '/duverne-informace/F38/page1555'
                },
                F45: {
                    url: '/duverne-informace/F45' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID39: {},
    profilID46: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    profilID49: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        SPECIALNI: {}
    },
    profilID50: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        SPECIALNI: {}
    },
    profilID52: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F39: {
                    url: '/duverne-informace/F39/page1710'
                }
            }
        }
    },
    profilID100: {
        DUVERNAOBLAST: {
            SLUZBYPRONE: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F15: {
                    url: '/duverne-informace/F15/page60b'
                },
                F16: {
                    url: '/duverne-informace/F16/page62b'
                },
                F17: {
                    url: '/duverne-informace/F17/page87b'
                },
                F18: {
                    url: '/duverne-informace/F18/page143b'
                },
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb'
                }
            }
        }
    },
    profilID35: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F15: {
                    url: '/duverne-informace/F15/page60b'
                },
                F16: {
                    url: '/duverne-informace/F16/page62b'
                },
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F38: {
                    url: '/duverne-informace/F38/page1544'
                },
                F39: {
                    url: '/duverne-informace/F39/page1716'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F17: {
                    url: '/duverne-informace/F17/page87b'
                },
                F18: {
                    url: '/duverne-informace/F18/page143b'
                },
                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            DALSIINFORMACE: {
                F5: {
                    url: '/duverne-informace/F5/page153b'
                },
                F6: {
                    url: '/duverne-informace/F6/page146b'
                },
                F7: {
                    url: '/duverne-informace/F7/page152b'
                },
                F8: {
                    url: '/duverne-informace/F8/page147b'
                },
                F20: {
                    url: '/duverne-informace/F20/page156b'
                },
                F50: {
                    url: '/duverne-informace/F50/page733'
                },
                F52: {
                    url: '/duverne-informace/F52/page779'
                },
                F53: {
                    url: '/duverne-informace/F53/page757'
                },
                F56: {
                    url: '/duverne-informace/F56/page744'
                },
                F58: {
                    url: '/duverne-informace/F58/page740'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        SPECIALNI: {}
    },

    profilID2A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb'
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID5A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID6A: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page197'
                },

                F28: {
                    url: '/duverne-informace/F28/page605'
                },
                F30: {
                    url: '/duverne-informace/F30/page197'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID10A: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID25A: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID26A: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID28A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID29A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID38A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F38: {
                    url: '/duverne-informace/F38/page1555'
                },
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID39A: {
        DUVERNAOBLAST: {
            WRSPRAVA: {
                WRUZIVATELE: {
                    WRNOVYUZIVATEL: {
                        url: routePathEnum.UZIVATELE_NOVY
                    },
                    WRSEZNAMUZIVATELU: {
                        url: routePathEnum.UZIVATELE_PREHLED
                    }
                }
            }
        }
    },
    profilID46A: {
        DUVERNAOBLAST: {
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page625'
                },

                F28: {
                    url: '/duverne-informace/F28/page92b'
                },
                F30: {
                    url: '/duverne-informace/F30/page625'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID49A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        SPECIALNI: {},
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID50A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F45: {
                    url: '/duverne-informace/F45'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        },
        SPECIALNI: {},
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID52A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F39: {
                    url: '/duverne-informace/F39/page1710'
                }
            }
        },
        WRSPRAVA: {
            WRUZIVATELE: {
                WRSEZNAMUZIVATELU: {
                    url: routePathEnum.UZIVATELE_PREHLED
                },
                WRNOVYUZIVATEL: {
                    url: routePathEnum.UZIVATELE_NOVY
                }
            }
        }
    },
    profilID100A: {
        DUVERNAOBLAST: {
            SLUZBYPRONE: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F15: {
                    url: '/duverne-informace/F15/page60b'
                },
                F16: {
                    url: '/duverne-informace/F16/page62b'
                },
                F17: {
                    url: '/duverne-informace/F17/page87b'
                },
                F18: {
                    url: '/duverne-informace/F18/page143b'
                },
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb'
                }
            },
            WRSPRAVA: {
                WRUZIVATELE: {
                    WRNOVYUZIVATEL: {
                        url: routePathEnum.UZIVATELE_NOVY
                    },
                    WRSEZNAMUZIVATELU: {
                        url: routePathEnum.UZIVATELE_PREHLED
                    }
                }
            }
        }
    },
    profilID35A: {
        DUVERNAOBLAST: {
            EMISECENNYCHPAPIRU: {
                F15: {
                    url: '/duverne-informace/F15/page60b'
                },
                F16: {
                    url: '/duverne-informace/F16/page62b'
                },
                F25: {
                    url: '/duverne-informace/F25/page57b'
                },
                F26: {
                    url: '/duverne-informace/F26/page64b'
                },
                F38: {
                    url: '/duverne-informace/F38/page1544'
                },
                F39: {
                    url: '/duverne-informace/F39/page1716'
                },
                F45: {
                    url: '/duverne-informace/F45/cnb' // emit , adic, cnb = cislo jednaci, isin textbox + tabulka.
                }
            },
            UCTYVLASTNIKA: {
                F9: {
                    url: '/duverne-informace/F9/page95b'
                },

                F17: {
                    url: '/duverne-informace/F17/page87b'
                },
                F18: {
                    url: '/duverne-informace/F18/page143b'
                },
                F27: {
                    url: '/duverne-informace/F27/page140b'
                },
                F28: {
                    url: '/duverne-informace/F28/page637'
                },
                F30: {
                    url: '/duverne-informace/F30/page95b'
                }
            },
            DALSIINFORMACE: {
                F5: {
                    url: '/duverne-informace/F5/page153b'
                },
                F6: {
                    url: '/duverne-informace/F6/page146b'
                },
                F7: {
                    url: '/duverne-informace/F7/page152b'
                },
                F8: {
                    url: '/duverne-informace/F8/page147b'
                },
                F20: {
                    url: '/duverne-informace/F20/page156b'
                },
                F50: {
                    url: '/duverne-informace/F50/page733'
                },
                F52: {
                    url: '/duverne-informace/F52/page779'
                },
                F53: {
                    url: '/duverne-informace/F53/page757'
                },
                F56: {
                    url: '/duverne-informace/F56/page744'
                },
                F58: {
                    url: '/duverne-informace/F58/page740'
                }
            },
            INFORMACEZAUPLATU: {
                F1: {
                    url: '/duverne-informace/F1/page63b'
                },
                F1A: {
                    url: '/duverne-informace/F1A/page800'
                }
                /* F3: {
                    url: '/duverne-informace/F3/page49b'
                } */
            }
        }
    },
    SPECIALNI: {}
};
